import { render } from "./WiseLocaleSelector.vue?vue&type=template&id=47309814"
import script from "./WiseLocaleSelector.vue?vue&type=script&lang=js"
export * from "./WiseLocaleSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__